import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { globalPropTypes } from 'helpers';
import editReducer, { defaultState, setEditDataCreator, updateFieldCreator } from './reducer';
import {
  loadClientMemberAssociationsByCBCreator,
  loadGlobalCisCertificatesAttributesCreator,
  setIpmaCisEditErrorsCreator,
  updateIpmaCisCreator,
} from '../../../../../store/actionsCreators';
import EditCertificate from '../../../../../shared/Cis/Certificates/Edit/EditCertificate';

function EditIpmaCertificate({
  certificate,
  errors,
  updateCertificate,
  removeError,
  levelDomains,
  certificationBodies,
  loadCertificatesAttributes,
  organizations,
  loadClientMemberAssociations,
  memberAssociations,
  languages,
}) {
  const [state, dispatch] = useReducer(editReducer, defaultState);

  useEffect(() => {
    if (certificate) {
      dispatch(setEditDataCreator(certificate));
    }
  }, [certificate]);

  return (
    <EditCertificate
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      updateCertificate={updateCertificate}
      removeError={removeError}
      levelDomains={levelDomains}
      certificationBodies={certificationBodies}
      loadCertificatesAttributes={loadCertificatesAttributes}
      organizations={organizations}
      loadClientMemberAssociations={loadClientMemberAssociations}
      memberAssociations={memberAssociations}
      type="ipma"
      languages={languages}
    />
  );
}

EditIpmaCertificate.propTypes = {
  certificate: PropTypes.shape({
    id: PropTypes.number,
    certificateHolder: PropTypes.number,
    levelDomain: PropTypes.number,
    certificationBody: PropTypes.number,
    issueDate: PropTypes.any,
    type: PropTypes.string,
    validUntil: PropTypes.any,
    certId: PropTypes.string,
    holderAuthorized: PropTypes.bool,
    visibility: PropTypes.bool,
    organization: PropTypes.number,
    memberAssociation: PropTypes.number,
  }),
  errors: PropTypes.shape({
    certificateHolder: PropTypes.string,
    certificateLevelDomain: PropTypes.string,
    certificationBody: PropTypes.string,
    issueDate: PropTypes.string,
    type: PropTypes.string,
    validUntil: PropTypes.string,
    certId: PropTypes.string,
    holderAuthorized: PropTypes.string,
    visibility: PropTypes.string,
    organization: PropTypes.string,
    memberAssociation: PropTypes.string,
  }),
  updateCertificate: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
  certificationBodies: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  levelDomains: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  loadCertificatesAttributes: PropTypes.func.isRequired,
};

EditIpmaCertificate.defaultProps = {
  certificate: null,
  errors: {},
};

const mapStateToProps = ({ ipma, globals }) => ({
  certificate: ipma.cis.certificates.profile,
  errors: ipma.cis.certificates.editErrors,
  certificationBodies: globals.cis.certificationBodies,
  levelDomains: globals.cis.levelDomains,
  organizations: globals.cis.organizations,
  memberAssociations: globals.cis.clientMemberAssociations,
  languages: globals.languages,
});

const mapDispatchToProps = (dispatch) => ({
  updateCertificate: (id, payload, history) =>
    dispatch(updateIpmaCisCreator(id, 'certificates', payload, history)),
  removeError: (payload) => dispatch(setIpmaCisEditErrorsCreator('certificates', payload)),
  loadCertificatesAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
  loadClientMemberAssociations: (payload) =>
    dispatch(loadClientMemberAssociationsByCBCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditIpmaCertificate);
